import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = ["id", "name", "value", "checked"]
const _hoisted_3 = { class: "text-left whitespace-pre-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("label", {
    for: _ctx.id,
    class: "flex items-center select-none"
  }, [
    _createElementVNode("input", {
      id: _ctx.id,
      hidden: "",
      type: "checkbox",
      name: _ctx.name,
      value: _ctx.value,
      checked: _ctx.selected,
      onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.change(_ctx.value)))
    }, null, 40, _hoisted_2),
    _createElementVNode("span", {
      class: _normalizeClass(["block rounded-full border border-next-dark-gray mr-2 cursor-pointer shrink-0", [_ctx.selected ? 'border-next-orange bg-next-orange':'', _ctx.checkClass ]])
    }, null, 2),
    _createElementVNode("span", _hoisted_3, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 8, _hoisted_1))
}